(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sbg-monarchs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const link = event.target.closest('.sbg-monarch-photo');
    if (!link) return;
    event.preventDefault();
    const links = [...document.querySelectorAll('.sbg-monarch-photo')];
    let index = links.indexOf(link);
    let viewer = document.querySelector('.sbg-monarch-viewer');
    if (!viewer) {
      viewer = document.createElement('dialog');
      viewer.className = 'sbg-monarch-viewer';
      viewer.innerHTML = '<button type="button" class="sbg-monarch-viewer__close" aria-label="Close photograph">×</button><button type="button" class="sbg-monarch-viewer__prev" aria-label="Previous photograph">‹</button><div class="sbg-monarch-viewer__frame"><img alt=""><span class="sbg-monarch-copyright" aria-hidden="true">© Soul Body Gems</span></div><button type="button" class="sbg-monarch-viewer__next" aria-label="Next photograph">›</button>';
      document.body.appendChild(viewer);
      viewer.querySelector('.sbg-monarch-viewer__close').addEventListener('click', () => viewer.close());
      viewer.addEventListener('click', e => { if (e.target === viewer) viewer.close(); });
    }
    const show = n => {
      index = (n + links.length) % links.length;
      const selected = links[index];
      const img = viewer.querySelector('img');
      img.src = selected.href;
      img.alt = selected.querySelector('img').alt;
    };
    viewer.querySelector('.sbg-monarch-viewer__prev').onclick = () => show(index - 1);
    viewer.querySelector('.sbg-monarch-viewer__next').onclick = () => show(index + 1);
    viewer.onkeydown = e => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    };
    show(index);
    viewer.showModal();
  });

  } catch(e) { console.error(e); }
})();
})();
